import Client from "@/repositories/Clients/AxiosClient";
import Config from "@/repositories/Clients/AxiosDefaultConfig";
import { prepareSearchParams } from "@/libs/helper";

const resource = `${Config.basePath}/report`;

export default {
  chart(payload) {
    return Client.get(`${resource}/call/satification`, {
      params: payload,
    });
  },
  index(payload) {
    return Client.get(`${resource}/satification/call`, {
      params: prepareSearchParams(payload),
    });
  },
  exportExcel(payload) {
    return Client.get(`${resource}/satification/call/export`, {
      params: payload,
      responseType: "blob",
    });
  },
};
